import React, { useRef,useEffect } from 'react';
import "./styles.css";

/**
 * @function UITextInput
 * @param {STRING} className - Additional classes to add to the UITextInput.
 * @param {STRING} placeholder - Sets the label and placeholder text.
 * @param {STRING} value - lets us set a default value if we need to.
 * @param {ReactDOM} inputField - Allows us to target the DOM.
 * @param {FUNCTION} onChange - Allows us to listen for an interaction with the input.
 * @param {STRING} placeholderText - Sets the placeholder text when it shouldn't have a floating label.
 * @return {React.Component}
 * @exported true
 * @description This is an input with a placeholder that floats up as a label.
 * @example
 * <UITextInput className="added-class" value={someFunction} placeholder="Always pay" />
 */
export default function UITextInput(props) {
  const className = props.className ?? "";
  const placeholderText = props.placeholderText !== undefined ? (props.placeholderText) : (" ");
  const placeholder = props.placeholder ?? "";
  const value = props.value ?? "";
  const inputField = useRef();
  const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};
  const type = props.type ?? "text";
  const maxLengthProps = props.maxLength !== undefined ? { maxLength: props.maxLength } : {};
  const autoCompleteNewPasswordProp = type === "password" ? { autoComplete: "new-password" } : {};

  const onChange = props.onChange === undefined 
    ? (evt) => undefined 
    : (evt) => props.onChange(inputField.current.value, evt, inputField.current);
    const onFocus = props.onFocus === undefined 
    ? (evt) => undefined 
    : (evt) => props.onFocus(inputField.current.value, evt, inputField.current);
    const onBlur = props.onBlur === undefined 
    ? (evt) => undefined 
    : (evt) => props.onBlur(inputField.current.value, evt, inputField.current);
    useEffect(() => {inputField.current.value = value??""}, [ value ]);
 
  return(
    <div className={className + " ui-text-input"}>
      <div className="floating-label-input-container">
        <input className="floating-label-input" { ...maxLengthProps } { ...autoCompleteNewPasswordProp  } ref={ inputField } type={ type } placeholder={placeholderText} value={value} onChange={ onChange } {...dataPoint} onFocus={onFocus} onBlur={onBlur} onClick={props.onClick}></input>
        <label className="floating-label">{ placeholder }</label>
        {props.children}
      </div>
    </div>
  );
}